import styled from 'styled-components';
import { Modal } from 'UI';

export const SModal = styled(Modal)`
  padding: 0;
  border-radius: 24px;
  overflow: hidden;
  .ant5-modal-content,
  .ant5-modal-body {
    padding: 0;
    overflow: hidden;
    border-radius: 24px;
  }
`;
